/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
<div class="ck-card" :class="[`payment-${selected}`]">
    <!-- resume section -->
    <div v-show="!editMode" class="ck-card-resume">
      <a
        class="ck-card-edit btn btn-none bcm-link bcm-link-underline-primary"
        href="#"
        @click.prevent="goToEdit(true)">{{$t('Edit')}}</a>
      <b class="text-uppercase">3. {{ $t('PaymentsMethods') }}</b>
      <div class="ck-card-detail">
        {{ selected }}
      </div>
    </div>
    <!-- edit section -->
    <div class="card-text" v-show="editMode">
      <div class="ck-card-title">{{ $t('PaymentsMethods') }}</div>
      <div class="ck-edit-form">
        <b-form-group
          id="group-shipping-payment"
          label-for="shipping-payment">
          <b-form-radio-group
            id="shipping-payment"
            class="radio-block-response"
            v-validate="'required'"
            v-model="selected"
            name="shipping-payment"
          >
            <b-form-radio
              v-for="item in options"
              :key="item.code"
              :value="item.code"
              :disabled="item.disabled"
            >
              <div class="label-left">{{item.title}}</div>
              <portal-target :name="`destination-${item.code}`"></portal-target>
            </b-form-radio>
          </b-form-radio-group>
        </b-form-group>
        <!-- payment body -->
        <portal :to="`destination-${selected}`">
          <component
          ref="paymentComponent"
          :payment-code="selected"
          @submit="submit"
          :is="selectedComp"/>
        </portal>
        <Agreements ref="agreements"/>
      </div>
    </div>
  </div>
</template>

<script>
import Config from 'config'
import GiftPay from 'theme/components/Checkout/PaymentMethods/Gifts/GiftPay'
import Agreements from './Agreements'
import Newsletter from 'theme/services/Newsletter'
import Logger from '@/services/Logger'
import { toast } from 'theme/modules/notifications'
import { EventBus } from '@/helpers'
import { axiosErrorMessage } from '@/helpers/utils'
import { processPayment } from 'theme/helpers/payments'

function getAgreementsIds (compAgree) {
  let aggrIds = []
  for (let key in compAgree.termsValue) {
    if (compAgree.termsValue[key]) {
      aggrIds.push(key)
    }
  }
  return aggrIds
}

export default {
  name: 'PaymentMethodForm',
  props: {
    value: {
      type: Boolean,
      default: () => false
    },
    name: {
      type: String,
      default: () => 'payment-method-form'
    },
    busListener: {
      type: String,
      required: false
    }
  },
  $_veeValidate: {
    validator: 'new',
    name () {
      return this.name
    }
  },
  data () {
    return {
      selected: null,
      editMode: true,
      hasPickup: false,
      paymentData: {
        code: ''
      }
    }
  },
  computed: {
    giftCards () {
      return this.$store.getters['cart/getGiftCards']
    },
    giftCardSelected () {
      return this.$store.getters['cart/getActiveGiftCards']
    },
    selectedComp () {
      switch (this.selected) {
        case 'GIFT_CERTIFICATE':
          return 'GiftPay'
        default:
          return null
      }
    },
    options () {
      const _this = this
      let paymentMethods = this.$store.state.checkout.paymentMethods
      let remappedPaymentMethods = []
      // remap payment method
      paymentMethods.forEach((payment) => {
        let pym
        if (payment.code === 'GIFT_CERTIFICATE') {
          pym = {
            title: payment.title,
            code: payment.code,
            disabled: false
          }
        } else if (!Config.Theme.forms.hidePayment.includes(payment.code)) {
          pym = {
            title: payment.title,
            code: payment.code,
            disabled: _this.giftCardSelected.length > 0
          }
        }
        remappedPaymentMethods.push(pym)
      })
      return remappedPaymentMethods
    }
  },
  methods: {
    edit (status) {
      this.editMode = status
    },
    goToEdit (status) {
      this.editMode = status
      EventBus.$emit('checkout:goto', 'payment-methods-section')
    },
    submit (placeorder) {
      this.paymentData = placeorder.paymentData
      this.confirmData()
    },
    updateOrder (orderId) {
      this.$store.commit('ui/showLoader')
      let payload = {
        params: {
          'c_storeId': this.$store.getters['userAdmin/getStoreId'],
          'c_shipToStore': this.$store.getters['checkout/getShipToStore'],
          'c_shipToStoreId': this.$store.getters['userAdmin/getUserStoreId'],
          'c_is_AppSales': true,
          'c_AppSales_store_id': this.$store.getters['userAdmin/getUserStoreId'],
          'c_AppSales_agent_id': this.$store.getters['userAdmin/getCurrentAgentID']
        }
      }
      // update order to new and go to thankyou
      return this.$store.dispatch('orders/updateOrder', { orderId, payload })
        .finally(() => {
          // go to typ
          this.$store.commit('ui/hideLoader')
          EventBus.$emit('placeorder:complete', { orderId })
        })
    },
    confirmData () {
      const _this = this
      // save shipping method
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          _this.paymentData.code = _this.selected
          return processPayment({ paymentMethod: _this.paymentData })
            .then((orderId) => {
              _this.beforeOrderComplete()
              return _this.updateOrder(orderId)
            })
            .catch(error => {
              let { err, orderId } = error
              const msg = _this.$t(axiosErrorMessage(err))
              Logger.error('error save payment method ', err)
              toast.error(msg)
              if (orderId) {
                return this.updateOrder(orderId)
              }
            })
        }
      })
    },
    trySubmit () {
      const extensionAttributes = {
        agreement_ids: getAgreementsIds(this.$refs.agreements)
      }
      this.$store.commit('checkout/extensionAttributes', extensionAttributes)
      if (this.$refs['paymentComponent'] && this.$refs['paymentComponent'].submit) {
        this.$refs['paymentComponent'].submit()
      } else {
        this.confirmData()
      }
    },
    beforeOrderComplete () {
      if (this.$refs.agreements && this.$refs.agreements.marketingTerm) {
        const _this = this
        let email = _this.$store.getters['checkout/email']
        if (email) {
          return Newsletter.subscribeCustomer(_this.$store.state.ui.storeViewCode, email)
            .then((res) => {
              if (res.data !== 'OK') {
                throw new Error('error')
              }
            })
            .catch((err) => {
              Logger.error(err)
            })
        }
      }
    }
  },
  mounted () {
    this.selected = this.$store.getters['checkout/getActivePaymentMethod']
    if (this.busListener) {
      EventBus.$on(`${this.busListener}:validateForm`, this.trySubmit)
    }
  },
  destroyed () {
    if (this.busListener) {
      EventBus.$off(`${this.busListener}:validateForm`, this.trySubmit)
    }
  },
  components: {
    Agreements,
    GiftPay
  }
}
</script>
